import React from 'react';
import Linkify from './Linkify';

export default function P({newlines, children, noMarginBottom, linkify = true }) {
    if (!children) return null
    let split = children.split('\n');
    return split.map((t, i) => <p style={!noMarginBottom?null:{marginBottom: i == split.length - 1 ? 0 : null}}key={i}>
        {linkify?<Linkify>{t}</Linkify>:t}
    </p>);
}